export default class Faq {
    constructor() {
        this.sections = document.querySelectorAll('.faq');
        this.ready();
    }
    
    ready() {
        
        this.sections.forEach(section => {
            
            const allQuestions = section.querySelectorAll('.faq-item')
            allQuestions.forEach(question => {
                const questionTitle = question.querySelector('.title')
                questionTitle.addEventListener('click', () => {
                    question.classList.toggle('active')
                })
            })

        })

    }
    
}

if (document.querySelector('.faq')) {
    new Faq();
}